import * as React from "react";
import { Alert, Modal } from "antd";
import { VolumeBrowserService } from "./volumesBrowser";
import { useAppSelector } from "../../../../store/hooks";
import { LoaderSmall } from "../../../../components/layout/loader/small";
import { KindSelect } from "../../../../components/antd/kindselect/KindSelect";
import { parseLink } from "../../../../utils/linkParser/linkParser";

interface Props {
  vbs: VolumeBrowserService;
}
export const VolumesProviderModal: React.FC<Props> = ({ vbs }) => {
  const bss = useAppSelector((state) => state.browserService);

  const [cavalue, setCavalue] = React.useState("");

  return (
    <Modal
      title={`Select ${vbs.provider === "azure" ? "Azure" : vbs.provider.toUpperCase()} Cloud Account`}
      width={500}
      open={vbs.page === "provider"}
      maskClosable={false}
      onCancel={() => {
        vbs.setCloudAccountName("");
        vbs.setPage("none");
      }}
      onOk={() => {
        vbs.prepare();
      }}
      okText={`Next`}
      okButtonProps={{
        disabled: !vbs.cloudAccountName || !bss.canReach || vbs.isCheckingReach,
        loading: vbs.isCheckingReach,
      }}
    >
      {vbs.isPreparing ? (
        <div className="flex items-center justify-center flex-col" style={{ height: 300 }}>
          <LoaderSmall />
          <div className="mt-2">Please wait. Loading items.</div>
        </div>
      ) : null}
      {vbs.provider === "aws" ? (
        <KindSelect
          className={`mb-4`}
          kind={"cloudaccount"}
          optionValue="name"
          value={cavalue}
          onChange={setCavalue}
          disabled={vbs.isPreparing}
          onStateChange={(state) => {
            const name = parseLink(state.link, { useInputCtx: true }).name;
            vbs.setCloudAccountName(name);
          }}
          queries={[{ property: "provider", value: "aws" }]}
        />
      ) : null}
      {vbs.provider === "azure" ? (
        <KindSelect
          className={`mb-4`}
          kind={"cloudaccount"}
          optionValue="name"
          value={cavalue}
          onChange={setCavalue}
          disabled={vbs.isPreparing}
          onStateChange={(state) => {
            const name = parseLink(state.link, { useInputCtx: true }).name;
            vbs.setCloudAccountName(name);
          }}
          queries={[{ property: "provider", value: "azure" }]}
        />
      ) : null}
      {vbs.provider === "gcp" ? (
        <KindSelect
          className={`mb-4`}
          kind={"cloudaccount"}
          optionValue="name"
          value={cavalue}
          onChange={setCavalue}
          disabled={vbs.isPreparing}
          onStateChange={(state) => {
            const name = parseLink(state.link, { useInputCtx: true }).name;
            vbs.setCloudAccountName(name);
          }}
          queries={[{ property: "provider", value: "gcp" }]}
        />
      ) : null}
      {vbs.prepareError ? (
        <Alert
          type={"error"}
          message={"This cloud account cannot reach the provider. Select another one."}
          description={vbs.prepareError}
        />
      ) : null}
      {bss.reachError ? <Alert type={"error"} message={bss.reachError} /> : null}
    </Modal>
  );
};
